import { MetricCard } from "../components/MetricCard";

export function Analytics() {
  return (
    <s-page heading="Analytics">
      <header className="page-header">
        <div>
          <s-paragraph>Understand impressions, accepts, add-to-cart actions, and revenue.</s-paragraph>
        </div>
      </header>
      <section className="metrics-grid">
        <MetricCard label="Cross-sell revenue" value="$1,522" />
        <MetricCard label="Service revenue" value="$2,758" />
        <MetricCard label="Declines" value="8,900" />
        <MetricCard label="Checkout events" value="10,642" />
      </section>
      <s-section heading="Daily metrics">
        <div className="chart-placeholder" aria-label="Revenue chart preview" />
      </s-section>
    </s-page>
  );
}
